import { Button } from "Components/_Shared/Buttons/Button";
import { DialogModal } from "Components/_Shared/DialogModal";
import type { SearchedClient } from "Infrastructure/ApiZfp/Schema";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { getSearchedClientName } from "Infrastructure/Utils/ClientUtils";

type Props = {
  readonly client: SearchedClient | null;
  readonly onContinue: (client: SearchedClient) => void;
  readonly onClearBirthNumber: () => void;
};

export const FoundClientDialog = ({ client, onContinue, onClearBirthNumber }: Props) => {
  const { t } = useResource();

  return (
    <DialogModal
      size="sm"
      isOpen={client !== null}
      onClose={onClearBirthNumber}
      closeLabel={t(Resources.NewAnalysis.FoundClientDialog.ClearBirthNumber)}
      title={t(Resources.NewAnalysis.FoundClientDialog.Title)}
      subtitle={t(Resources.NewAnalysis.FoundClientDialog.Text, { client: client ? getSearchedClientName(client) : "" })}
      primaryAction={<Button onClick={() => client && onContinue(client)}>{t(Resources.NewAnalysis.FoundClientDialog.Continue)}</Button>}
    />
  );
};
